import { render, staticRenderFns } from "./ClientsSideviewDevicesTab.vue?vue&type=template&id=982a9184&scoped=true&class=fill-height"
import script from "./ClientsSideviewDevicesTab.vue?vue&type=script&lang=ts"
export * from "./ClientsSideviewDevicesTab.vue?vue&type=script&lang=ts"
import style0 from "./ClientsSideviewDevicesTab.vue?vue&type=style&index=0&id=982a9184&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982a9184",
  null
  
)

export default component.exports